"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TumblrIconCircle = exports.TumblrIconFill = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TumblrIconFill = exports.TumblrIconFill = function TumblrIconFill() {
  return _react2.default.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
    _react2.default.createElement("path", { d: "M13.5.5v5h5v4h-5V15c0 5 3.5 4.4 6 2.8v4.4c-6.7 3.2-12 0-12-4.2V9.5h-3V6.7c1-.3 2.2-.7 3-1.3.5-.5 1-1.2 1.4-2 .3-.7.6-1.7.7-3h3.8z" })
  );
};

var TumblrIconCircle = exports.TumblrIconCircle = function TumblrIconCircle() {
  return _react2.default.createElement(
    "svg",
    {
      version: "1.1",
      x: "0px",
      y: "0px",
      width: "24px",
      height: "24px",
      viewBox: "0 0 24 24",
      enableBackground: "new 0 0 24 24",
      xmlSpace: "preserve"
    },
    _react2.default.createElement("path", { d: "M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12s12-5.383,12-12S18.617,0,12,0z M15.492,17.616C11.401,19.544,9.5,17,9.5,14.031 V9.5h-2V8.142c0.549-0.178,1.236-0.435,1.627-0.768c0.393-0.334,0.707-0.733,0.943-1.2c0.238-0.467,0.401-0.954,0.49-1.675H12.5v3h2 v2h-2v3.719c0,2.468,1.484,2.692,2.992,1.701V17.616z" })
  );
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-social-sharing/dist-modules/svg/tumblr.js
 ** module id = 1343
 ** module chunks = 0
 **/